<template>
  <div class="container-fluid">
    <validation-observer
      ref="v-observer"
      v-slot="{
        valid
      }"
    >
      <div class="row">
        <div class="col table-responsive mt-2">
          <h5 class="card-title text-muted">
            <strong> {{ $t('customer.basket') }} </strong>
          </h5>
          <div class="float-left d-inline-flex">
            <button
              class="btn btn-danger btn-sm text-center m-1"
              @click="clearProductsBasket"
            >
              {{ $t("buttons.cleanBasket") }}
            </button>
          </div>
          <table class="table  table-bordered table-striped p-2">
            <thead>
              <tr>
                <th scope="col">L.P.</th>
                <th class="width-mid" scope="col"> {{ $t('basket.product') }}</th>
                <th scope="col"> {{ $t('basket.price') }}</th>
                <th scope="col" colspan="2" >
                  {{ $t('basket.quantity') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="order.lines.length == 0">
                <td
                  colspan="12"
                  class="text-center"
                >
                  {{ $t('orders.empty') }}
                </td>
              </tr>
              <cart-line
                v-for="(line,index) in order.lines"
                :key="line.id"
                :line="line"
                :index-line="index"
                @quantity="handleQuantityChange(line, $event)"
                @price="handlePriceChange(line, $event)"
                @remove="removeProduct"
              />
            </tbody>
            <tfoot v-if="order.lines.length > 0">
              <tr>
                <td
                  colspan="4"
                  class="text-right"
                >
                  {{ $t('customer.summary') }}
                </td>
                <td class="text-right">
                  {{ currencyDisplay(totalPrice, false) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
<!--      <div class="row">-->
<!--        <div class="col float-right">-->
<!--          <div class="input-group-prepend">-->
<!--            <div class="input-group-text">-->
<!--              <span class="m-1">  {{ $t('orders.discountAllBasket') }} </span>-->
<!--              <input-->
<!--                id="discountGlobal"-->
<!--                class="form-control"-->
<!--                type="number"-->
<!--                :value="discountGlobalInputValue"-->
<!--                @input="generateGlobalDiscount($event)"-->
<!--              >-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="row">
        <div class="col">
          <div class="text-center">
            <router-link
              to="/products"
              class="btn btn-secondary m-1"
            >
              {{ $t('buttons.addProductOrder') }}
            </router-link>
            <button
              :disabled="!valid"
              class="btn btn-theme-add m-1"
              @click="onNextClick"
            >
              {{ $t('buttons.nextStep') }}
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import CartLine from "./ShoppingCartLine";
import { ValidationObserver } from 'vee-validate';
import { currencyMixin } from '../mixins';

export default {
  components: { CartLine, ValidationObserver },
  mixins: [currencyMixin],
  data: function() {
    return {
      discountGlobalInputValue: 0
    }
  },
  computed: {
    ...mapState('cart', ['order']),
    ...mapState('currency', ['ratio']),
    ...mapGetters('cart', ['totalPrice'])
  },
  mounted () {
    this.$refs['v-observer'].validate();
  },
  methods: {
    ...mapActions('cart', ['checkCustomerExist']),
    ...mapMutations('cart', [
      'changeQuantity',
      'removeProduct',
      'changeDescription',
      'changePrice',
      'setCartData'
    ]),
    handleQuantityChange(line, $event) {
      this.changeQuantity({ line, change: $event });
    },
    handleDiscountChange(line, $event) {
      this.changeDiscount({line, change: $event, ratio: this.ratio })
    },
    handlePriceChange(line, $event) {
      this.changePrice({ line, change: $event, ratio: this.ratio })
    },
    onNextClick () {
      this.$refs['v-observer'].validate().then(result => {
        if (result) {
          this.$router.push('/checkout')
        }
      })
    },
    clearProductsBasket(){
      this.setCartData([]);
      localStorage.removeItem("cart");
    },
    // generateGlobalDiscount($event){
    //   let lines = this.$store.state.cart.order.lines;
    //   let discountGlobalInput = $event.target.value;
    //   if(Number(discountGlobalInput) > 0 ){
    //     for (let i in this.$store.state.cart.order.lines) {
    //       this.discountGlobalInputValue = $event.target.value;
    //       this.handleDiscountChange(lines[i], this.discountGlobalInputValue);
    //     }
    //   }else {
    //     this.discountGlobalInputValue = 0;
    //     for (let i in this.$store.state.cart.order.lines) {
    //       this.discountGlobalInputValue = $event.target.value;
    //       this.handleDiscountChange(lines[i], 0);
    //     }
    //   }
    // }
  }
};
</script>
